import { Stack, Typography } from "@mui/material";
import React from "react";
import ProfileDataCard from "./ProfileDataCard";
import { Cancel, CheckCircle } from "@mui/icons-material";

interface AvailabilityProps {
  workingWeekend: boolean;
  availabilitySelectionWeekend: "kannImmer" | "nichtFR" | "nichtSA" | "nichtSO" | null;
}

/**
 * This component displays the availability of an applicant.
 * @param workingWeekend Whether the applicant is available on the working weekend.
 * @param availabilitySelectionWeekend The availability selection for the weekend.
 * @returns The availability of an applicant.
 */
const Availability = ({ workingWeekend, availabilitySelectionWeekend }: AvailabilityProps) => {
  /**
   * This Component displays the availability of the applicant on the selection weekend.
   * @returns The availability of the applicant on the selection weekend.
   */
  const SelectionWeekendAvailability = () => {
    switch (availabilitySelectionWeekend) {
      case "kannImmer":
        return (
          <Typography>
            Kann <strong>immer</strong> am Auswahlwochenende.
          </Typography>
        );
      case "nichtFR":
        return (
          <Typography>
            Kann <strong>nicht am Freitag</strong> am Auswahlwochenende.
          </Typography>
        );
      case "nichtSA":
        return (
          <Typography>
            Kann <strong>nicht am Samstag</strong> am Auswahlwochenende.
          </Typography>
        );
      case "nichtSO":
        return (
          <Typography>
            Kann <strong>nicht am Sonntag</strong> am Auswahlwochenende.
          </Typography>
        );
      default:
        return <Typography></Typography>;
    }
  };

  return (
    <ProfileDataCard title="Verfügbarkeit">
      <Stack spacing={2}>
        <Stack spacing={1} direction="row" alignItems="center">
          <Typography fontWeight={"bold"}>Working Weekend</Typography>
          {workingWeekend ? (
            <CheckCircle color="success" fontSize="small" />
          ) : (
            <Cancel color="error" fontSize="small" />
          )}
        </Stack>
        <SelectionWeekendAvailability />
      </Stack>
    </ProfileDataCard>
  );
};

export default Availability;
